<section class="legal-page">
  <div class="legal-wrap">
    <header class="legal-head">
      <p class="legal-eyebrow">{{ updatedKey | translate }}</p>
      <h1>{{ titleKey | translate }}</h1>
    </header>
    <div class="legal-body" [innerHTML]="bodyKey | translate"></div>
  </div>
</section>
